module.exports = __webpack_public_path__ + "img/about-us-01.d442cf93.webp";